<div *ngIf="!desableStatus">
    <input
      type="checkbox"
      [(ngModel)]="data[isSelectedVar]"
      name="isSelected"
      [disabled]="isDisabled()"
      (change)="onSelectChange()"
      [checked]="isChecked"
    />
  </div>
  <div *ngIf="desableStatus">
    <input
      type="checkbox"
      [(ngModel)]="data[isSelectedVar]"
      name="isSelected"
      [disabled]="isDisabled()"
      (change)="onSelectChange()"
      disabled="disabled"
      [checked]="isChecked"
    />
  </div>